export default function IconCursor(props) {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" {...props}>
      <path d="M4 4l6 18 3-7 7-3z"/>
    </svg>
  )
}
